export default __webpack_public_path__ + "static/media/responsive-demo-facebook-clone.4012dbda.png";